import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { useEffect, useState } from "react";
import API from "./services/api";

import AppShell from "./layouts/AppShell";
import Login from "./pages/Login";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import Dashboard from "./pages/Dashboard";
import Alerts from "./pages/Alerts";
import Operators from "./pages/Operators";
import Finances from "./pages/Finances";

function App() {
  const [authLoading, setAuthLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        const response = await API.get("/auth/me");

        if (response.data?.admin) {
          localStorage.setItem("admin", JSON.stringify(response.data.admin));

          setAuthenticated(true);
        } else {
          setAuthenticated(false);
        }
      } catch (error) {
        setAuthenticated(false);
      } finally {
        setAuthLoading(false);
      }
    };

    checkAuthentication();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute
              authLoading={authLoading}
              authenticated={authenticated}
            >
              <AppShell>
                <Dashboard />
              </AppShell>
            </PrivateRoute>
          }
        />

        <Route
          path="/clients"
          element={
            <PrivateRoute
              authLoading={authLoading}
              authenticated={authenticated}
            >
              <AppShell>
                <Clients />
              </AppShell>
            </PrivateRoute>
          }
        />

        <Route
          path="/client/:id"
          element={
            <PrivateRoute
              authLoading={authLoading}
              authenticated={authenticated}
            >
              <AppShell>
                <ClientDetail />
              </AppShell>
            </PrivateRoute>
          }
        />
        <Route
          path="/alerts"
          element={
            <PrivateRoute
              authLoading={authLoading}
              authenticated={authenticated}
            >
              <AppShell>
                <Alerts />
              </AppShell>
            </PrivateRoute>
          }
        />
        <Route
          path="/operators"
          element={
            <PrivateRoute
              authLoading={authLoading}
              authenticated={authenticated}
            >
              <AppShell>
                <Operators />
              </AppShell>
            </PrivateRoute>
          }
        />
        <Route
          path="/finances"
          element={
            <PrivateRoute
              authLoading={authLoading}
              authenticated={authenticated}
            >
              <AppShell>
                <Finances />
              </AppShell>
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

function PrivateRoute({ children, authLoading, authenticated }) {
  if (authLoading) {
    return null;
  }

  if (!authenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default App;
